import { Rocket, Phone, FileText } from "lucide-react";

/**
 * Sticky bottom CTA bar visible only on mobile.
 * Three actions: start quote flow, call, view requirements.
 */
export default function MobileCTABar() {
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 flex md:hidden items-center justify-around py-2.5 px-2 border-t"
      style={{
        background: "hsl(var(--secondary) / 0.97)",
        borderColor: "hsl(0 0% 100% / 0.1)",
        backdropFilter: "blur(12px)",
      }}
    >
      <a
        href="#guia"
        className="flex flex-col items-center gap-0.5 text-[10px] font-semibold transition-opacity hover:opacity-80"
        style={{ color: "hsl(var(--accent))" }}
      >
        <Rocket className="w-5 h-5" />
        Empezar
      </a>
      <a
        href="tel:+15107083587"
        className="flex flex-col items-center gap-0.5 text-[10px] font-semibold transition-opacity hover:opacity-80"
        style={{ color: "hsl(0 0% 100%)" }}
      >
        <Phone className="w-5 h-5" />
        Llamar
      </a>
      <a
        href="#estados"
        className="flex flex-col items-center gap-0.5 text-[10px] font-semibold transition-opacity hover:opacity-80"
        style={{ color: "hsl(0 0% 100%)" }}
      >
        <FileText className="w-5 h-5" />
        Requisitos
      </a>
    </div>
  );
}
